import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsVisibleOnGridBaseValueConverter {
    toView(array) {
        if(ObjectHelper.IsNullOrUndefined(array)) {
            return new Array<Object>();
        }
        return array.filter((item) => item['VisibleOnGrid'] == 1);
    }
}